import React from 'react';
import { css } from '@bts-web/utils-style-engine';
import { SVGIconType } from '../types';

const RegularSell: React.FC<SVGIconType> = ({
  color,
  size = 22,
  width,
  height,
  className,
  ...restProps
}) => {
  const wrapperClassName = css({
    color: color || 'neutrals.text_primary',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: width || size,
    height: height || size,
  });

  return (
    <span
      data-testid="icon_sell"
      className={
        className ? `${wrapperClassName} ${className}` : wrapperClassName
      }
      data-element="icon"
      aria-label="sell icon"
      {...restProps}
    >
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        width={`${size}px`}
        height={`${size}px`}
        fill="currentcolor"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9997 2C11.5162 2 11.0356 2.08263 10.5846 2.2449C10.1336 2.40717 9.71782 2.6471 9.36321 2.95512C9.00842 3.2633 8.72079 3.6346 8.52228 4.05087C8.32358 4.46755 8.21947 4.91846 8.21947 5.37683V6.5H4.51418C3.49041 6.5 2.68163 7.36166 2.75457 8.37468L3.58518 19.9103C3.66996 21.0877 4.65759 22 5.84754 22H18.1525C19.3424 22 20.33 21.0877 20.4148 19.9103L21.2454 8.37468C21.3184 7.36166 20.5096 6.5 19.4858 6.5H15.7799V5.37683C15.7799 4.91846 15.6758 4.46756 15.477 4.05087C15.2785 3.6346 14.9909 3.2633 14.6361 2.95512C14.2815 2.6471 13.8658 2.40717 13.4147 2.2449C12.9637 2.08263 12.4831 2 11.9997 2ZM14.2678 6.5V5.37683C14.2678 5.14528 14.2154 4.91302 14.1102 4.6923C14.0047 4.47117 13.8469 4.26331 13.64 4.08364C13.433 3.90381 13.182 3.75676 12.8992 3.65501C12.6164 3.55326 12.3105 3.5 11.9997 3.5C11.6889 3.5 11.383 3.55326 11.1001 3.65501C10.8174 3.75676 10.5663 3.90381 10.3593 4.08364C10.1525 4.26331 9.99459 4.47117 9.88914 4.6923C9.78388 4.91302 9.73155 5.14528 9.73155 5.37683V6.5H14.2678ZM4.26281 8.26781C4.25239 8.1231 4.36793 8 4.51418 8H19.4858C19.6321 8 19.7476 8.1231 19.7372 8.26781L18.9066 19.8034C18.8783 20.1959 18.5491 20.5 18.1525 20.5H5.84754C5.45089 20.5 5.12168 20.1959 5.09342 19.8034L4.26281 8.26781Z"
        />
        <path d="M12.7563 17.0006C12.7563 17.4148 12.4178 17.7506 12.0002 17.7506C11.5827 17.7506 11.2442 17.4148 11.2442 17.0006L11.2442 13.2921L9.50671 14.9905C9.20929 15.2812 8.73061 15.2777 8.43754 14.9826C8.14448 14.6876 8.14801 14.2127 8.44543 13.922L11.47 10.9655C11.7644 10.6778 12.2371 10.6778 12.5314 10.9656L15.5552 13.9225C15.8526 14.2133 15.856 14.6881 15.5629 14.9831C15.2698 15.2781 14.7911 15.2815 14.4937 14.9907L12.7563 13.2917L12.7563 17.0006Z" />
      </svg>
    </span>
  );
};

export { RegularSell };
